import { Dayjs } from "dayjs";
import { useMemo } from "react";
import { useGetMassTimeseriesQuery } from "src/store/api/generatedApi";
import type { MassDataPoint } from "src/store/api/generatedApi";

interface UseScaleWeightsResult {
  series: MassDataPoint[];
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
}

export const useScaleWeights = ({
  tenantName,
  start,
  end,
  downsample,
  skip = false,
}: {
  tenantName: string;
  start: Dayjs;
  end: Dayjs;
  downsample: number;
  skip?: boolean;
}): UseScaleWeightsResult => {
  const { currentData, isLoading, isFetching, isError } =
    useGetMassTimeseriesQuery(
      {
        tenantName,
        start: start.toISOString(),
        end: end.toISOString(),
        downsample,
      },
      { skip }
    );

  // currentData, not data: when the period changes, the previous period's
  // points must not be drawn as if they belonged to the one on screen.
  const series = useMemo(() => currentData?.series ?? [], [currentData]);

  return { series, isLoading, isFetching, isError };
};
